import { render, staticRenderFns } from "./safeWorkPermitUserSetting.vue?vue&type=template&id=7af1760a"
import script from "./safeWorkPermitUserSetting.vue?vue&type=script&lang=js"
export * from "./safeWorkPermitUserSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7af1760a')) {
      api.createRecord('7af1760a', component.options)
    } else {
      api.reload('7af1760a', component.options)
    }
    module.hot.accept("./safeWorkPermitUserSetting.vue?vue&type=template&id=7af1760a", function () {
      api.rerender('7af1760a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/setting/safeWorkPermitUserSetting.vue"
export default component.exports